import React from "react";
import { FiFacebook, FiInstagram } from "react-icons/fi";
import { FaTelegramPlane } from "react-icons/fa";
import "../assets/css/about.css";
import { Link } from "react-router-dom";
const About = () => {
  const icons = [<FiFacebook />, <FiInstagram />, <FaTelegramPlane />];
  return (
    <div className="about ">
      <div className="container">
        <div className="row justify-content-center py-4">
          <div className="col-md-7 col-lg-8">
            <div className="about_card">
              <div className="card__body">
                <h1 className="card__header">Что такое Telegogle?</h1>
                <p className="desc">
                  А ещё многие известные личности преданы
                  социально-демократической анафеме. Мы вынуждены отталкиваться
                  от того, что понимание сути ресурсосберегающих технологий
                  говорит о возможностях поэтапного и последовательного развития
                  общества.{" "}
                </p>{" "}
                <br />
                <p className="desc">
                  А ещё многие известные личности преданы
                  социально-демократической анафеме. Мы вынуждены отталкиваться
                  от того, что понимание сути ресурсосберегающих технологий
                  говорит о возможностях поэтапного и последовательного развития
                  общества.{" "}
                </p>
                <br />
                <p className="desc">
                  А ещё многие известные личности преданы
                  социально-демократической анафеме. Мы вынуждены отталкиваться
                  от того, что понимание сути ресурсосберегающих технологий
                  говорит о возможностях поэтапного и последовательного развития
                  общества.{" "}
                </p>
                <br />
                <li className="socials">
                  {icons.map((item, index) => (
                    <li key={index}>
                      <Link to="/">{item}</Link>
                    </li>
                  ))}
                </li>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
